function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F9B8A2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3111 26.8241C28.0607 26.8241 27.8104 26.7286 27.6193 26.5377L25.6459 24.5649C25.2639 24.183 25.2639 23.5638 25.6459 23.1819C26.0279 22.8 26.6474 22.8 27.0294 23.1819L29.0028 25.1547C29.3848 25.5365 29.3848 26.1558 29.0028 26.5377C28.8118 26.7286 28.5614 26.8241 28.3111 26.8241Z",
  fill: "#E86767"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3376 15.0888C26.0872 15.0888 25.8369 14.9934 25.6459 14.8024C25.2639 14.4205 25.2639 13.8013 25.6459 13.4194L27.6193 11.4466C28.0014 11.0647 28.6207 11.0647 29.0028 11.4466C29.3848 11.8284 29.3848 12.4477 29.0028 12.8296L27.0294 14.8024C26.8384 14.9933 26.588 15.0888 26.3376 15.0888Z",
  fill: "#E86767"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.023 19.9705H27.2322C26.6919 19.9705 26.2539 19.5327 26.2539 18.9926C26.2539 18.4525 26.6919 18.0146 27.2322 18.0146H30.023C30.5633 18.0146 31.0013 18.4525 31.0013 18.9926C31.0013 19.5327 30.5633 19.9705 30.023 19.9705Z",
  fill: "#E86767"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3434 22.7418L13.3051 22.7394C13.004 22.7212 12.7136 22.6659 12.4379 22.5791L10.5108 25.9158C10.3343 26.2215 10.4417 26.6125 10.7496 26.7852L12.6465 27.849C12.9491 28.0187 13.332 27.9136 13.5055 27.6132L16.319 22.7418H13.3434Z",
  fill: "#E86767"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2987 11.2544L16.5742 14.759V23.9731L22.3059 27.3781C22.7284 27.6291 23.2635 27.3247 23.2635 26.8335V11.7947C23.2635 11.2997 22.721 10.9959 22.2987 11.2544Z",
  fill: "#E86767"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2104 24.3364H14.2285C12.6137 24.255 11.3047 23.1675 11.3047 21.8259V17.0258C11.3047 15.6842 12.6137 14.5967 14.2285 14.6781H19.2104V24.3364Z",
  fill: "#E86767"
});

var SvgBroadcastIcon = function SvgBroadcastIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBroadcastIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/broadcast-icon.cc4657af.svg";
export { ForwardRef as ReactComponent };